import { api } from './api';

export type GroupRole = 'ADMIN' | 'MEMBER';

export interface Group {
  id: string;
  companyId: string;
  name: string;
  description?: string;
  isDefault: boolean;
  createdAt: string;
  updatedAt: string;
  _count?: {
    members: number;
    sites: number;
  };
}

export interface GroupMember {
  id: string;
  groupId: string;
  userId: string;
  role: GroupRole;
  createdAt: string;
  user?: {
    id: string;
    name: string;
    phone?: string | null;
  };
}

export interface CreateGroupDto {
  name: string;
  description?: string;
}

export interface UpdateGroupDto {
  name?: string;
  description?: string;
}

export interface AddGroupMemberDto {
  userId: string;
  role?: GroupRole;
}

interface ApiResponse<T> {
  success: boolean;
  data: T;
  error: null | { code: string; message: string };
}

export const groupsApi = {
  findAll: async (companyId: string): Promise<Group[]> => {
    const response = await api.get<ApiResponse<Group[]>>(`/organizations/${companyId}/groups`);
    return response.data.data;
  },

  create: async (companyId: string, data: CreateGroupDto): Promise<Group> => {
    const response = await api.post<ApiResponse<Group>>(`/organizations/${companyId}/groups`, data);
    return response.data.data;
  },

  update: async (companyId: string, groupId: string, data: UpdateGroupDto): Promise<Group> => {
    const response = await api.patch<ApiResponse<Group>>(`/organizations/${companyId}/groups/${groupId}`, data);
    return response.data.data;
  },

  delete: async (companyId: string, groupId: string): Promise<void> => {
    await api.delete(`/organizations/${companyId}/groups/${groupId}`);
  },

  getMembers: async (companyId: string, groupId: string): Promise<GroupMember[]> => {
    const response = await api.get<ApiResponse<GroupMember[]>>(`/organizations/${companyId}/groups/${groupId}/members`);
    return response.data.data;
  },

  addMember: async (companyId: string, groupId: string, data: AddGroupMemberDto): Promise<GroupMember> => {
    const response = await api.post<ApiResponse<GroupMember>>(`/organizations/${companyId}/groups/${groupId}/members`, data);
    return response.data.data;
  },

  removeMember: async (companyId: string, groupId: string, userId: string): Promise<void> => {
    await api.delete(`/organizations/${companyId}/groups/${groupId}/members/${userId}`);
  },
};
